import { useNavigate } from "@tanstack/react-router"
import type { FC } from "react"
import { useCallback } from "react"

import { CompetitorProductsFilter } from "./CompetitorProductsFilter"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"

interface CompetitorProductsFilterDrawerProps {
  isOpen: boolean
  onToggle: () => void
}

export const CompetitorProductsFilterDrawer: FC<CompetitorProductsFilterDrawerProps> = ({ isOpen, onToggle }) => {
  const navigate = useNavigate({ from: "/app/admin/manage-products/competitor-products" })

  const handleClearFilters = useCallback(() => {
    navigate({
      search: (prev) => ({
        ...prev,
        distributorIds: undefined,
      }),
      replace: true,
    })
  }, [navigate])

  return (
    <SearchFilterDrawer toggleDrawer={onToggle} open={isOpen} clear={handleClearFilters} width={380}>
      <CompetitorProductsFilter />
    </SearchFilterDrawer>
  )
}
